import React from 'react'
import { WidgetProps } from '@rjsf/utils'

import { FeedbotAce } from '../../../FeedbotAce/FeedbotAce'

export type ModeEditor = 'css' | 'xml' | 'javascript' | 'json' | 'markdown'

interface Props {
  mode?: ModeEditor
  isReadOnly?: boolean
  isWrapTextEnabled?: boolean
}

export const EditorWidget: React.FC<Props & WidgetProps> = ({
  mode,
  value,
  uiSchema,
  isReadOnly,
  onChange,
  ...props
}) => {
  const focus = uiSchema?.focus
  const resize = uiSchema?.resizeCssRule
  const initialRowsCount = uiSchema?.initialRowsCount
  const isWrapTextEnabled = props.isWrapTextEnabled ?? uiSchema?.isWrapTextEnabled

  return (
    <FeedbotAce
      mode={mode}
      value={value}
      focus={focus}
      resizeCssRule={resize}
      isReadOnly={isReadOnly}
      initialRowsCount={initialRowsCount}
      isWrapTextEnabled={isWrapTextEnabled}
      onChange={onChange}
    />
  )
}
